import React, { useEffect, useState } from 'react';
import { Sparkles, Star } from 'lucide-react';

/**
 * Capa decorativa de estrellas/sparkles. Responsive:
 *   - Móvil (<768px): muestra `mobileCount` estrellas
 *   - Desktop (≥768px): muestra `desktopCount` estrellas (o `count` si no se pasa)
 *
 * Posiciones aleatorias pero estables (se generan una sola vez al montar).
 * Opacidad baja para no robar protagonismo al contenido.
 */
export const SparkleField = ({ count = 2, mobileCount, desktopCount, className = '' }) => {
  const desk = desktopCount ?? count;
  const mob = mobileCount ?? Math.min(1, desk);
  const [n, setN] = useState(mob);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(min-width: 768px)');
    const apply = () => setN(mq.matches ? desk : mob);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, [desk, mob]);

  // Genera los items la primera vez con el conteo más alto, luego solo "muestra" los primeros n
  const [pool] = useState(() =>
    Array.from({ length: Math.max(desk, mob) }).map((_, i) => ({
      id: i,
      top: 8 + Math.random() * 84,
      left: 6 + Math.random() * 88,
      size: 14 + Math.random() * 18,
      delay: Math.random() * 3,
      duration: 2.5 + Math.random() * 2.5,
      color: i % 3 === 0 ? '#FCD34D' : i % 3 === 1 ? '#F472B6' : '#D8B4E2',
      Icon: i % 2 === 0 ? Sparkles : Star,
    }))
  );

  const visible = pool.slice(0, n);

  return (
    <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {visible.map((s) => (
        <s.Icon
          key={s.id}
          className="absolute animate-twinkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            color: s.color,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            opacity: 0.55,
          }}
          strokeWidth={1.5}
          fill={s.Icon === Star ? 'currentColor' : 'none'}
        />
      ))}
    </div>
  );
};
